import type {CreateUserFormPayload} from "./create-user.schema";

import {createUser} from "@project/sdk/admin";
import {mutationOptions} from "@tanstack/react-query";

import {userMutationKeys} from "../../user-keys";

import {createUserMapper} from "./create-user.mapper";

/**
 * Mutation option factory for creating a user.
 *
 * Declares the mutationKey (for DevTools + setMutationDefaults targeting) and
 * the mutationFn. Additional callbacks (onSuccess, onError) belong in
 * the UI layer alongside useQueryClient().
 *
 * Usage in a component:
 *   const mutation = useMutation({
 *     ...createUserMutationOptions(),
 *     onSuccess: (user) => { ... },
 *   });
 */
export function createUserMutationOptions() {
  return mutationOptions({
    mutationFn: (payload: CreateUserFormPayload) => {
      const request = createUserMapper.toSdk(payload);

      return createUser(request);
    },
    mutationKey: userMutationKeys.create(),
  });
}
